import { createContext, PropsWithChildren, useContext } from "react"
import { HttpValidationError, MeResponse } from "../config/api"
import { getMeApiV3MeGetOptions } from "../config/api/@tanstack/react-query.gen"
import { QueryObserverResult, RefetchOptions, useQuery } from "@tanstack/react-query"
import { AxiosError } from "axios"

const MeContext = createContext<{
  me?: MeResponse,
  loading: boolean,
  error: null|AxiosError<HttpValidationError>,
  refetch: (options?: RefetchOptions) => Promise<QueryObserverResult<MeResponse, AxiosError<HttpValidationError>>>,
  org: string,
}|undefined>(undefined)

interface Props extends PropsWithChildren {
  org: string
}

export function MeProvider({children, org}: Props) {
  const {data, isPending: loading, error, refetch} = useQuery({
    ...getMeApiV3MeGetOptions()
  })

  return <MeContext.Provider value={{me: data, loading, error, refetch, org}}>
    {children}
  </MeContext.Provider>
}

// No pun intended
export function useMe() {
  const state = useContext(MeContext)

  if (!state) {
    throw Error("Trying to use 'MeContext' outside of MeProvider.")
  }

  return state
}
